import { render } from "./SpecialStudentsComponent.vue?vue&type=template&id=e450e592&scoped=true"
import script from "./SpecialStudentsComponent.vue?vue&type=script&lang=js"
export * from "./SpecialStudentsComponent.vue?vue&type=script&lang=js"

import "./SpecialStudentsComponent.vue?vue&type=style&index=0&id=e450e592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e450e592"]])

export default __exports__